import React from 'react';
import { Box, Icon, IconWrapper, Copy } from '@honda-canada/design-system-react';
import PropTypes from 'prop-types';
import themeStyles from './styles/PaymentOverview.styles';

const ErrorContainer = themeStyles.apply(Box, 'ErrorContainer');
const ErrorIcon = themeStyles.apply(Icon, 'ErrorIcon');
const ErrorCopy = themeStyles.apply(Copy, 'ErrorCopy');
const ErrorContent = themeStyles.apply(Box, 'ErrorContent');
const ErrorIconWrapper = themeStyles.apply(IconWrapper, 'ErrorIconWrapper');

const Error = ({ message }) => (
  <ErrorContainer data-testid="cy-pricing-error">
    <ErrorContent>
      <ErrorIconWrapper size="iconWrapper.zero">
        <ErrorIcon name="information" />
      </ErrorIconWrapper>
      <ErrorCopy data-test-id="cy-price-error-message">{message}</ErrorCopy>
    </ErrorContent>
  </ErrorContainer>
);

Error.defaultProps = {
  message: 'Unable to load. Contact your local dealer',
};

Error.propTypes = {
  message: PropTypes.string,
};

export default Error;
